import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Custom hook to check if Schedule Service Request Due Date feature is enabled.
 * This feature allows scheduling due date while creating service requests.
 */
export function useScheduleServiceRequestDueDateEnabled() {
  const isEnabled = useFlag<boolean>(FeatureFlag.ScheduleServiceRequestDueDate, false);

  return Boolean(isEnabled);
}

